import { api } from './api';
import type { PaginatedResult } from '../types/admin';
import type { CXTemplateField } from '../types/cx';

export interface CrmTemplateDraft { name: string; subject: string; body_text: string; body_html?: string }
export interface CrmEmailTemplate extends CrmTemplateDraft { id: string; created_at: string; updated_at: string }
export interface CrmMessagePreview { subject: string; body: string; body_html?: string; preview_html?: string; warnings: string[]; sample: boolean }
const base = '/api/admin/crm/templates/';
export const CrmTemplatesAPI = {
  async list(): Promise<CrmEmailTemplate[]> {
    const rows: CrmEmailTemplate[] = [];
    let page = 1;
    while (true) {
      const { data } = await api.get<PaginatedResult<CrmEmailTemplate>>(`${base}?page_size=200&page=${page}`);
      rows.push(...data.results);
      if (!data.next) return rows;
      page += 1;
    }
  },
  async create(draft: CrmTemplateDraft) { return (await api.post<CrmEmailTemplate>(base, draft)).data; },
  async update(id: string, draft: CrmTemplateDraft) { return (await api.patch<CrmEmailTemplate>(`${base}${id}/`, draft)).data; },
  async remove(id: string) { await api.delete(`${base}${id}/`); },
  async fields() { return (await api.get<{ fields: CXTemplateField[] }>(`${base}fields/`)).data; },
  async preview(subject: string, body: string, lead_id?: string, account?: { organization_id: string; recipient: string }, body_html?: string) {
    return (await api.post<CrmMessagePreview>(`${base}preview/`, { subject, body, lead_id, ...account, ...(body_html ? { body_html } : {}) })).data;
  },
};
export const CRM_TEMPLATES_KEY = ['admin', 'crm', 'templates'];
